import {AssetLoader} from '../AssetLoader';
import {AudioManager} from '../AudioManager';
import {BreathSystem} from '../BreathSystem';
import {ClockScene} from '../ClockScene';
import {Component_BlendShape} from '../components/Component_BlendShape';
import {PlantScene} from '../PlantScene';
import {FSM} from './FSM';
import {Component_DeformRipple} from '../components/Component_DeformRipple';

////////////////////////////////////////////////////////////////
// In charge of loading
////////////////////////////////////////////////////////////////
export const FSM_LOAD_PLANT = FSM.getState(FSM.stateNames.LOAD_PLANT);
FSM_LOAD_PLANT.loaderLag = 0.2;
FSM_LOAD_PLANT.enter = function() {
  this.loaderCreep = 0;
  PlantScene.load();
};
FSM_LOAD_PLANT.execute = function(dt) {
  const progress = AssetLoader.getProgress();
  ClockScene.update(dt);

  // update loader shader
  if (this.loaderCreep < progress) {
    this.loaderCreep += (dt * FSM_LOAD_PLANT.loaderLag);
    ClockScene.loaderProgress(this.loaderCreep);
  }
  if (progress === 1 && this.loaderCreep >= 1) {
    ClockScene.hide();
    FSM.setState(FSM_PLANT);
  }
};
FSM_LOAD_PLANT.exit = function() {
  this.loaderCreep = 0;
  PlantScene.setup();
};

////////////////////////////////////////////////////////////////
// Display the plant scene
////////////////////////////////////////////////////////////////
export const FSM_PLANT = FSM.getState(FSM.stateNames.PLANT);
FSM_PLANT.enter = function() {
};
FSM_PLANT.execute = function(dt) {
  PlantScene.update(dt);
  Component_BlendShape.clockTick(dt);
};
FSM_PLANT.exit = function() {
  PlantScene.hideWelcomeMessages();
  // reveal scene switcher
  PlantScene.killSwitchRevealTimer();
};

// Breath in / out
export const FSM_PLANT_BREATH = FSM.getState(FSM.stateNames.PLANT_BREATH);
FSM_PLANT_BREATH.enter = function() {
  BreathSystem.start();
  Component_DeformRipple.MasterSettings.ripplePower = Component_DeformRipple.MasterSettings.ripplePower_breathe;
  AudioManager.fadeTo(AudioManager.fluteDrone, 0, 0, 8);
  AudioManager.fadeTo(AudioManager.bellsDrone, 0, 0, 10);
  AudioManager.fadeTo(AudioManager.choirDrone, 0, 0, 12);
};
FSM_PLANT_BREATH.execute = function(dt) {
  PlantScene.update(dt);
};
FSM_PLANT_BREATH.exit = function(dt) {
  BreathSystem.stop();

  Component_DeformRipple.MasterSettings.ripplePower = Component_DeformRipple.MasterSettings.ripplePower_normal;
  AudioManager.fadeTo(AudioManager.fluteDrone, 0.2, 0.2, 6);
  AudioManager.fadeTo(AudioManager.bellsDrone, 0.2, 0.2, 9);
  AudioManager.fadeTo(AudioManager.choirDrone, 0.2, 0.2, 12);
};
